import React from "react";
import { twMerge } from "tailwind-merge";

export type HeroContentProps = React.HTMLAttributes<HTMLDivElement>;

const HeroContent: React.FC<HeroContentProps> = ({
  className,
  children,
  ...props
}) => {
  const classes = twMerge("hero-content", className);

  return (
    <div {...props} className={classes}>
      {children}
    </div>
  );
};

export default HeroContent;
